import React, { useState, useLayoutEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const ScrollToHeroButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [fillPercentage, setFillPercentage] = useState(0);

  const scrollToHero = () => {
    document.getElementById('hero').scrollIntoView({ behavior: 'smooth' });
  };

  useLayoutEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const newFillPercentage = Math.min(100, (scrollY / documentHeight) * 100);

      setIsVisible(scrollY > 100); // Still show after 100px scroll
      setIsScrolled(scrollY > 100); // Still change arrow color after 100px scroll
      setFillPercentage(newFillPercentage);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <button
      className={`fixed bottom-6 right-6 z-50 p-3 rounded-full bg-white shadow-lg transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      onClick={scrollToHero}
      aria-label="Scroll to hero section"
      style={{
        background: `conic-gradient(#D9CAB3 ${fillPercentage * 3.6}deg, transparent 0deg)`, // 3.6deg per percentage point
      }}
    >
      <div
        className="relative w-full h-full rounded-full flex items-center justify-center"
        style={{
          backgroundColor: 'white', // Inner white circle
          transform: 'scale(0.85)', // Make it slightly smaller to reveal the conic-gradient border
        }}
      >
        <ChevronUp className={`h-6 w-6 ${isScrolled ? 'text-dark-green' : 'text-gray-800'}`} />
      </div>
    </button>
  );
};

export default ScrollToHeroButton;

